import { render } from "./freeShippingModel.vue?vue&type=template&id=5e4c523e"
import script from "./freeShippingModel.vue?vue&type=script&lang=js"
export * from "./freeShippingModel.vue?vue&type=script&lang=js"

import "./freeShippingModel.vue?vue&type=style&index=0&id=5e4c523e&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__